import React, { useRef, useState } from "react";
import Webcam from "react-webcam";
import { Button, Col, Offcanvas, Row } from "react-bootstrap";
import { BsCheckLg } from "react-icons/bs";
import { MdCached, MdCameraAlt, MdCameraswitch } from "react-icons/md";

const CameraComponent = (props) => {

    const camera = useRef(null);

    const [hasTakenPhoto, setHasTakenPhoto] = useState(false);
    const [showcaseImage, setShowcaseImage] = useState("");
    const [video, setVideo] = useState({
        width: "auto",
        height: "autos",
    });

    const switchCameraHanlder = () => {
        let var_video = {
            width: 720,
            height: 1280,
            facingMode: { exact: "environment" }
        };
        if (video.facingMode === "environment") {
            var_video.facingMode = "user";
        } else {
            var_video.facingMode = "environment";
        }
        setVideo(var_video);
    }

    const takePhotoHandler = () => {
        setShowcaseImage(camera.current.getScreenshot());
        setHasTakenPhoto(true);
    }

    const deletePhotoHandler = () => {
        setShowcaseImage("");
        setHasTakenPhoto(false);
    }

    const photoApprovedHandler = () => {
        props.setPhoto(showcaseImage);
        props.setData(prev => ({...prev,
            partner: ({...prev.partner, x_file_ausweiskopie: showcaseImage.split(",")[1]})
        }));
        props.setShow(false);
    }


    return (
        <Offcanvas onHide={() => props.setShow(false)} show={props.show} className="offcanvas-full">
            <Offcanvas.Header closeButton>
                <Offcanvas.Title>Kamera</Offcanvas.Title>
            </Offcanvas.Header>
            <Offcanvas.Body>
                <Row hidden={hasTakenPhoto} style={{display: "flex", height: 100}}>
                    <Col xs="12">
                        <div className="wrapper">
                            <Webcam
                                width="100%"
                                ref={camera}
                                videoConstraints={video}
                                style={{maxHeight: "88vh"}}
                            />
                        </div>
                    </Col>
                </Row>
                <Row className="mt-5 test-cls" style={{zIndex: 3}}>
                    <Col className="text-center">
                        <Button
                            hidden={hasTakenPhoto}
                            size="lg"
                            onClick={() => switchCameraHanlder()}
                            className="btn-energo"
                        >
                            <MdCameraswitch />
                        </Button> &nbsp;
                        <Button
                            hidden={hasTakenPhoto}
                            size="lg"
                            onClick={() => takePhotoHandler()}
                            className="btn-energo"
                        >
                            <MdCameraAlt />
                        </Button>
                        <Button
                            variant="warning"
                            hidden={!hasTakenPhoto}
                            size="lg"
                            onClick={() => deletePhotoHandler()}
                        >
                            <MdCached /> Erneut versuchen
                        </Button> &nbsp;
                        <Button
                            hidden={!hasTakenPhoto}
                            size="lg"
                            className="btn-energo"
                            onClick={() => photoApprovedHandler()}
                        >
                            <BsCheckLg /> Ich bin zufrieden
                        </Button>
                    </Col>
                </Row>
                <Row>
                    <Col className="text-center">
                        <img 
                            style={{maxHeight: "89vh", maxWidth: "95vw"}} 
                            src={showcaseImage} 
                            alt=""
                        />
                    </Col>
                </Row>
            </Offcanvas.Body>
        </Offcanvas>
    )
}

export default CameraComponent;